<template>
    <div>
        <sweet-modal blocking :title="activeIndex ? `${$t('settings_businessUnits_add')} ${btnText}` : $t('modal_businessUnits_add_selectEngagementTemplate')" ref="openModal" class="modal" v-on:close="closeModal">
            <form-wizard
                    shape="tab"
                    ref="wizard"
                    :start-index="0"
                    step-size="xs"
                    :color="color"
                    @on-change="handleTabChange"
                    @on-validate="handleValidation"
                    error-color="#f56c6c"
                    validate-on-back
                    title=""
                    subtitle=""
                    @on-complete="onComplete">

                <tab-content title="Select template"
                             icon="el-icon-edit-outline">
                    <el-row :span="24" :gutter="20">
                        <el-col :span="8">
                            <el-radio-group v-model="form.taskTreeId">
                                <el-row style="padding-bottom:5px;" v-for="item in form.taskTree" :key="item.id">
                                    <el-radio :label="item.id" @change="selectTemplate">{{item.name}}</el-radio>
                                </el-row>
                            </el-radio-group>
                        </el-col>
                        <el-col :span="16">
                            <div>
                                <img style="width:100%" :src="templateImgSrc" alt="template-img">
                            </div>
                        </el-col>
                    </el-row>
                </tab-content>

                <tab-content title="Settings"
                             icon="el-icon-check">
                    <el-alert
                            v-if="!form.clients.length"
                            title="Notification"
                            :closable="false"
                            type="warning"
                            show-icon>
                        <div slot class="alert-notification">
                            <div>
                                {{$t('modal_businessUnits_businessUnitPleaseAddClientToTheCompany')}}
                            </div>
                            <div>
                                <el-button type="primary" size="mini" plain @click="addClientOpenModal">{{$t('clients_btn_add')}}</el-button>
                            </div>
                        </div>
                    </el-alert>

                    <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
                        <el-form-item prop="name">
                            <el-input :label="$t('modal_businessUnits_businessUnitName')" v-model="form.name"></el-input>
                        </el-form-item>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item prop="code">
                                    <el-input :label="$t('modal_businessUnits_code')" maxlength="10" show-word-limit v-model="form.code"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="businessCenterId">
                                    <el-select no-data-text="no date" v-model="form.businessCenterId" :placeholder="$t('modal_businessUnits_businessCenter')" style="width: 100%;">
                                        <el-option
                                                v-for="item in form.businessCenters"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <!-- // TODO: Description -->
                        <el-form-item>
                            <el-button v-on:click="$refs.nestedChild.open()" style="width: 100%;">{{$t('modal_businessUnits_businessUnitDescription')}}</el-button>
                        </el-form-item>

                        <el-form-item prop="phone">
                            <el-input :label="$t('modal_businessUnits_phone')" v-model="form.phone"></el-input>
                        </el-form-item>
                        <el-form-item prop="phoneExtension">
                            <el-input :label="$t('modal_businessUnits_extension')" v-model="form.phoneExtension"></el-input>
                        </el-form-item>

                        <el-form-item prop="email">
                            <el-input :label="$t('modal_businessUnits_email')" v-model="form.email"></el-input>
                        </el-form-item>

                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item prop="managerId">
                                    <el-select v-model="form.managerId" :placeholder="$t('modal_businessUnits_manager')" style="width: 100%;">
                                        <el-option
                                                v-for="item in form.managers"
                                                :key="item.id"
                                                :label="item.user.fullName"
                                                :value="item.id"
                                                :class="{ disabled: item.status != 1 }"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="teamId">
                                    <el-select no-data-text="no date" @remove-tag="removeTag" v-model="form.teamId" multiple :placeholder="$t('modal_businessUnits_team')" style="width: 100%;">
                                        <el-option
                                                v-for="item in form.team"
                                                :key="item.id"
                                                :label="item.user.fullName"
                                                :value="item.id"
                                                :class="{ disabled: item.status != 1 }"
                                                @click.native="handleSelectTeam(item.id)">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <!--<el-form-item prop="taskTreeId">-->
                            <!--<el-select v-model="form.taskTreeId" :placeholder="$t('modal_businessUnits_taskTree')" style="width: 100%;">-->
                                <!--<el-option-->
                                        <!--v-for="item in form.taskTree"-->
                                        <!--:key="item.id"-->
                                        <!--:label="item.name"-->
                                        <!--:value="item.id"></el-option>-->
                            <!--</el-select>-->
                        <!--</el-form-item>-->

                        <el-row :gutter="20">
                            <el-col :span="12">
                              <!-- prop="clientsId" -->
                                <el-form-item>
                                    <el-select no-data-text="no date" v-model="form.clientsId" multiple :placeholder="$t('modal_businessUnits_clients')" style="width: 100%;">
                                        <el-option
                                                v-for="item in form.clients"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="vendorsId">
                                    <el-select no-data-text="no date" v-model="form.vendorsId" multiple :placeholder="$t('modal_businessUnits_vendors')" style="width: 100%;">
                                        <el-option
                                                v-for="item in form.vendors"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-form-item prop="profitCentre">
                                <el-col :span="24">
                                    <el-checkbox v-model="form.profitCentre">{{$t('modal_businessUnits_profitCentre')}}</el-checkbox>
                                </el-col>
                            </el-form-item>
                        </el-row>

                        <el-row v-if="form.profitCentre">
                            <el-form-item prop="bill">
                                <el-col :span="24">
                                    <el-radio-group v-model="form.bill">
                                        <el-radio :label="0">{{$t('modal_businessUnits_singleBill')}}</el-radio>
                                        <el-radio :label="1">{{$t('modal_businessUnits_progressBilling')}}</el-radio>
                                        <!--<el-radio :label="2">Not Billable</el-radio>-->
                                    </el-radio-group>
                                </el-col>
                            </el-form-item>
                        </el-row>
                        <el-row :span="24">
                            <el-col :span="12">
                                <el-form-item size="mini">
                                    <el-switch active-color="#13ce66" v-model="form.notifyTeam"></el-switch> {{$t('modal_notifyBUManagers')}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!--<el-form-item class="modal__btn">-->
                            <!--<el-button @click="modalCancel('openModal')">{{$t('modal_businessUnits_cancel')}}</el-button>-->
                            <!--<el-button @click="addItem('form')" type="primary">{{$t('modal_businessUnits_submit')}}</el-button>-->
                        <!--</el-form-item>-->
                    </el-form>
                </tab-content>
                <el-button type="primary" slot="prev">{{$t('modal_businessUnits_cancel')}}</el-button>
                <el-button  type="primary" slot="next">{{$t('general_next')}}</el-button>
                <el-button type="primary" slot="finish">{{$t('modal_businessUnits_submit')}}</el-button>
            </form-wizard>
        </sweet-modal>

        <sweet-modal blocking ref="nestedChild">
            <vue-editor
                    v-model="form.description"
                    useCustomImageHandler
                    @image-added="handleImageAdded"
            ></vue-editor>
            <el-button slot="button" v-on:click="$refs.nestedChild.close()" type="primary">{{$t('modal_businessUnits_submit')}}</el-button>
        </sweet-modal>

        <sweet-modal title="Adjust Permissions" width="500" blocking ref="permissions">
          <div class="permissions">
            <div>Need to adjust Team (User) permissions?</div>
            <div>Go to the Info Tab and select Permissions</div>
            <br>
            <div>For more information click on the link below</div>
            <div><a href="https://totalflow.io/permissions" target="_blank">www.totalflow.io/permissions</a></div>
          </div>
        </sweet-modal>

        <add-client-form-modal ref="modal11" :directories="directories" @selected="selectClient"/>
    </div>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import { VueEditor } from 'vue2-editor'

  import axios from 'axios'
  import AddClientFormModal from "../../../clients/AddClientForm";
  export default {
    name: "CreateBusinessUnitModalWizzard",
    components:{
      AddClientFormModal,
      SweetModal,
      VueEditor
    },
    computed: {
      companyLayout() {
        return this.$store.state.companyLayout
      }
    },
    data(){
      return{
        color:'rgb(52, 152, 219)',
        templateImgSrc: 'https://dev.totalflow.io/downloads/2020/12/18/4d2baa59d22719b775ce77794e50a0de.png',
        btnText:this.$i18n.t('settings_businessUnits'),
        activeIndex: 0,
        form:{
          bill: 0,
          profitCentre: false,
          name: '',
          code: '',
          businessCenters: [],
          businessCenterId: '',
          description: '',
          phone: '',
          phoneExtension: '',
          email:'',
          managers: [],
          managerId:'',
          team:'',
          teamId:[],
          clients:'',
          clientsId: [],
          vendors: '',
          vendorsId: [],
          taskTree:[{
            name: this.$t('modal_BusinessUnits_add_buildNewTaskTree'),
            id: '0'
          }],
          notifyTeam: true,
          taskTreeId: '0',
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          code: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          businessCenterId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          managerId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          teamId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          clientsId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ]
        },
        directories: null
      }
    },
    methods:{
      openModal(){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnits/directories?companyId=${this.$route.query.companyId}&operation=create&businessUnitId=0`)
          .then(response => {
            console.log('---', response.data);
            if (response.data.success) {
              for (let i = 0; i < response.data.businessUnitTemplateList.length; i++){
                this.form.taskTree.push(response.data.businessUnitTemplateList[i])
              }
              this.form.businessCenters = response.data.businessCenterList;
              this.form.managers = response.data.companyUserList;
              this.form.team = response.data.companyUserList;
              this.form.clients = response.data.companyClientList;
              this.form.vendors = response.data.companyVendorList;

              this.$refs.openModal.open()
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      selectTemplate(templateId){
        const selectedTemplate = this.form.taskTree.filter(val => val.id === templateId);
        this.templateImgSrc = selectedTemplate[0].templateImgUrl ? selectedTemplate[0].templateImgUrl : 'https://dev.totalflow.io/downloads/2020/12/18/4d2baa59d22719b775ce77794e50a0de.png';
      },
      removeTag(userId){
        if(this.form.managerId === userId) {
          this.form.managerId = null
        }
      },
      handleSelectManager(leaderId){
        const even = (element) => element === leaderId;
        const ifUserInTeam = this.form.teamId.some(even);
        if (!ifUserInTeam) {
          this.form.teamId.push(leaderId)
        }
      },
      handleSelectTeam(userId){
        const even = (element) => element === userId;
        const ifUserInTeam = this.form.teamId.some(even);
        if(!ifUserInTeam && this.form.managerId === userId) {
          this.form.managerId = null
        }
      },
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/businessUnits/create?companyId=${this.$route.query.companyId}`, {

                name: this.form.name,
                description: this.form.description,
                phone: this.form.phone,
                phone2: this.form.phoneExtension,
                email: this.form.email,
                managerCompanyUserId: this.form.managerId,
                companyUserIdList: this.form.teamId,
                businessUnitTemplateId: this.form.taskTreeId,
                businessCenterIdList: [this.form.businessCenterId],
                code: this.form.code,
                companyClientIdList: this.form.clientsId,
                companyVendorIdList: this.form.vendorsId,
                profitCentre: this.form.profitCentre ? 1 : 0,
                notifyTeam: this.form.notifyTeam,
                bill: this.form.bill,
              })
              .then(async response => {
                try {
                  await this.$store.dispatch('getCompanyLayout');
                  this.loadList();
                  this.$refs.openModal.close();
                  loader.hide()
                } catch (err){
                  loader.hide();
                  console.log(err)
                }
                this.$refs.permissions.open()
              })
              .catch(error => {
                loader.hide();
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        console.log("FILE",file);
        // this.form.imageUrl = URL.createObjectURL(file.raw);
        // console.log('---', this.form.imageUrl);
        const formData = new FormData();
        formData.append('file', file);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            let url = response.data.fileUrl // Get url from response
            Editor.insertEmbed(cursorLocation, 'image', url);
            resetUploader();
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          })
      },
      handleTabChange(prevIndex, nextIndex){
        // your logic here
        // console.log(this.VueFormWizard)
        console.log('OnChange', prevIndex, 'nextIndex', nextIndex);
        this.activeIndex = nextIndex;
      },
      handleValidation: function(isValid, tabIndex){
        // console.log('Tab: '+tabIndex+ ' valid: '+isValid)
      },
      loadList(){
        this.$emit('loadList')
      },
      onComplete: function(){
        this.addItem('form')
      },
      closeModal(){
        this.activeIndex = 0;
        this.form.description = '';
        this.templateImgSrc = 'https://dev.totalflow.io/downloads/2020/12/18/4d2baa59d22719b775ce77794e50a0de.png';
        this.form.taskTree = [{
          name: this.$t('modal_BusinessUnits_add_buildNewTaskTree'),
          id: '0'
        }];
        this.form.notifyTeam = false;
        this.$refs.wizard.navigateToTab(0);
        this.$refs['form'].resetFields();
      },
      addClientOpenModal(){
        this.$refs['modal11'].openModal()
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/client-vendor/directories?companyId=${this.$route.query.companyId}&&type=client&countryId=${this.companyLayout.currency.id}`)
          .then(response => {
            this.directories = response.data.list
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      async selectClient(id) {
        try {
          this.form.clientsId.push(id);
          const directories = await this.loadDirectories();
          this.form.clients = directories.companyClientList
        } catch (err) {
          console.log(err)
        }
      },
      loadDirectories(){
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/businessUnits/directories?companyId=${this.$route.query.companyId}&operation=create&businessUnitId=0`)
            .then(response => {
              console.log('---', response.data);
              resolve(response.data)
            })
            .catch(error => {
              reject(error)
              console.log('An error occurred:', error);
            });
        })
      }
    }
  }
</script>


<style lang="less" scoped>
    /deep/.wizard-header{
        display:none;
    }
    /deep/.vue-form-wizard .wizard-nav-pills{
        display:none;
    }
    /deep/.wizard-progress-with-circle {
        display:none;
    }
    /deep/.el-alert__content{
        width: 100%;
        .el-alert__description {
            width: 100%;
            .alert-notification {
                display:flex;
                width: 100%;
                align-items: center;
                justify-content:space-between;
            }
        }
    }
    .permissions {
      font-size: 20px;
    }
</style>
